export const SS_HELP_WEBSITE = "https://help.thespecsheet.com";
export const SS_PRIVACY_POLICY = "https://www.thespecsheet.com/privacy-policy";
export const SS_TERMS_OF_USE = "https://www.thespecsheet.com/terms-of-use";
